var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mt-4 space-y-2" },
    _vm._l(_vm.items, function (item, i) {
      return _c(
        "div",
        {
          key: i,
          staticClass: "rounded-md p-4 shadow-sm",
          class: _vm.bgColor(item.code),
        },
        [
          _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              { staticClass: "flex-shrink-0" },
              [
                item.code === 1
                  ? [
                      _c(
                        "svg",
                        {
                          staticClass: "h-5 w-5 text-green-400",
                          attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ]
                  : item.code === 2
                  ? [
                      _c(
                        "svg",
                        {
                          staticClass: "h-5 w-5 text-yellow-400",
                          attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ]
                  : item.code === 3
                  ? [
                      _c(
                        "svg",
                        {
                          staticClass: "h-5 w-5 text-red-400",
                          attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ]
                  : [
                      _c(
                        "svg",
                        {
                          staticClass: "h-5 w-5 text-blue-400",
                          attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ],
              ],
              2
            ),
            _c("div", { staticClass: "ml-3" }, [
              _c(
                "p",
                { staticClass: "text-sm leading-5 font-medium text-green-800" },
                [_vm._v(_vm._s(item.message))]
              ),
            ]),
            _c("div", { staticClass: "ml-auto pl-3" }, [
              _c("div", { staticClass: "-mx-1.5 -my-1.5" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150",
                    class: _vm.svgColor(item.code),
                    attrs: { "aria-label": "Dismiss" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.dismiss(i)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "h-5 w-5",
                        attrs: { viewBox: "0 0 20 20", fill: "currentColor" },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                            "clip-rule": "evenodd",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }